// import React, { useState, useEffect, useRef } from "react";
// import { useData } from "../context/DataContext";
// import { useAuth } from "../context/AuthContext";
// import { ordersAPI } from "../api";

// const BottomSheet = ({ visible, order, onClose, onTake, userId }) => {
//     const panelRef = useRef(null);

//     useEffect(() => {
//         if (visible) {
//             panelRef.current?.classList.remove("translate-y-full");
//             panelRef.current?.classList.add("translate-y-0");
//         }
//     }, [visible]);

//     const close = () => {
//         panelRef.current?.classList.add("translate-y-full");
//         setTimeout(onClose, 300);
//     };

//     if (!order) return null;

//     const handleTake = async () => {
//         try {
//             await ordersAPI.takeOrderWithUser(order.orderNumber, userId);
//             onTake(order.orderNumber);
//             close();
//         } catch (err) {
//             alert("Не удалось взять заказ");
//         }
//     };

//     return (
//         <div className={`fixed inset-0 z-50 ${visible ? "block" : "hidden"}`}>
//             <div className="absolute inset-0 bg-black/50" onClick={close}></div>
//             <div
//                 ref={panelRef}
//                 className="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl p-5 transform translate-y-full transition-transform duration-300"
//                 style={{ maxHeight: "80vh" }}>
//                 <div className="flex justify-center mb-4">
//                     <div className="w-12 h-1 bg-gray-300 rounded-full" />
//                 </div>
//                 <div className="overflow-y-auto max-h-96">
//                     <h2 className="text-2xl font-bold mb-1">№ {order.orderNumber}</h2>
//                     <p className="text-gray-700">{order.city}</p>
//                     <p className="text-gray-700">
//                         {order.title} {order.brand}
//                     </p>
//                     <p className="text-gray-700">Возраст: {order.age} лет</p>
//                     <p className="text-gray-700">Представиться: {order.partner}</p>
//                     <p className="text-gray-700">Описание: {order.description}</p>
//                     <p className="text-gray-700">Озвучены цены: {order.priceText}</p>
//                     <p className="text-gray-700">Комиссионные: {order.commission}</p>
//                     <p className="text-gray-700">
//                         Быть: {order.appointmentDate} {order.appointmentTime}
//                     </p>
//                     <p className="text-gray-700">Клиент: {order.clientName}</p>
//                     <p className="text-gray-700">Дата заявки: {order.requestDate}</p>
//                     <p className="text-gray-700">Доп. инфо: {order.additionalInfo || "—"}</p>
//                 </div>
//                 <button onClick={handleTake} className="w-full bg-blue-500 py-4 rounded-full mt-4 text-white font-medium text-lg">
//                     Взять заказ
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default function OrdersScreen() {
//     const { availableOrders, refreshAvailableOrders, takeOrder } = useData();
//     const { user } = useAuth();
//     const [selectedOrder, setSelectedOrder] = useState(null);
//     const [sheetVisible, setSheetVisible] = useState(false);
//     const [viewedOrders, setViewedOrders] = useState([]);

//     // Автоматически запрашиваем заказы при монтировании и при фокусе окна
//     useEffect(() => {
//         refreshAvailableOrders();

//         const onFocus = () => refreshAvailableOrders();
//         window.addEventListener("focus", onFocus);
//         return () => window.removeEventListener("focus", onFocus);
//     }, [refreshAvailableOrders]);

//     const openDetails = (order) => {
//         setSelectedOrder(order);
//         setSheetVisible(true);
//         if (!viewedOrders.includes(order.id)) {
//             setViewedOrders((prev) => [...prev, order.id]);
//             if (user?.uid_master) {
//                 ordersAPI.viewOrder(order.orderNumber, user.uid_master).catch((e) => console.log(e));
//             }
//         }
//     };

//     return (
//         <div className="px-4 pt-4">
//             <h2 className="text-2xl font-bold text-gray-800 mb-4">Доступные заказы</h2>

//             {/* Временный отладочный блок: покажет количество заказов в консоли и на экране */}
//             {process.env.NODE_ENV === "development" && <div className="text-xs text-gray-400 mb-2">Загружено заказов: {availableOrders.length}</div>}

//             {availableOrders.length === 0 ? (
//                 <div className="text-center text-gray-500 py-10">Нет доступных заказов</div>
//             ) : (
//                 availableOrders.map((item) => (
//                     <div key={item.id} className="bg-white p-4 mb-3 rounded-xl shadow-sm border border-gray-100">
//                         {!viewedOrders.includes(item.id) ? (
//                             <>
//                                 <div className="text-lg font-bold text-blue-600">НОВЫЙ ЗАКАЗ!</div>
//                                 <div className="text-gray-700">№ {item.orderNumber}</div>
//                             </>
//                         ) : (
//                             <div className="text-lg font-bold text-gray-800">№ {item.orderNumber}</div>
//                         )}
//                         <div className="text-gray-700">{item.city}</div>
//                         <div className="text-gray-700">Техника: {item.title}</div>
//                         <button onClick={() => openDetails(item)} className="mt-3 bg-blue-500 px-5 py-2 rounded-full text-white">
//                             Подробно
//                         </button>
//                     </div>
//                 ))
//             )}

//             <BottomSheet visible={sheetVisible} order={selectedOrder} onClose={() => setSheetVisible(false)} onTake={takeOrder} userId={user?.uid_master} />
//         </div>
//     );
// }

import React, { useState, useEffect, useRef } from "react";
import { useData } from "../context/DataContext";
import { useAuth } from "../context/AuthContext";
import { ordersAPI } from "../api";

const BottomSheet = ({ visible, order, onClose, onTake, userId }) => {
    const panelRef = useRef(null);

    useEffect(() => {
        if (visible) {
            panelRef.current?.classList.remove("translate-y-full");
            panelRef.current?.classList.add("translate-y-0");
        }
    }, [visible]);

    const close = () => {
        panelRef.current?.classList.add("translate-y-full");
        setTimeout(onClose, 300);
    };

    if (!order) return null;

    const handleTake = async () => {
        try {
            await ordersAPI.takeOrderWithUser(order.orderNumber, userId);
            onTake(order.orderNumber);
            close();
        } catch (err) {
            alert("Не удалось взять заказ");
        }
    };

    return (
        <div className={`fixed inset-0 z-50 ${visible ? "block" : "hidden"}`}>
            <div className="absolute inset-0 bg-black/50" onClick={close}></div>
            <div
                ref={panelRef}
                className="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl p-5 transform translate-y-full transition-transform duration-300"
                style={{ maxHeight: "80vh" }}>
                <div className="flex justify-center mb-4">
                    <div className="w-12 h-1 bg-gray-300 rounded-full" />
                </div>
                <div className="overflow-y-auto max-h-96">
                    <h2 className="text-2xl font-bold mb-1">№ {order.orderNumber}</h2>
                    <p className="text-gray-700">{order.city}</p>
                    <p className="text-gray-700">
                        {order.title} {order.brand}
                    </p>
                    <p className="text-gray-700">Возраст: {order.age} лет</p>
                    <p className="text-gray-700">Представиться: {order.partner}</p>
                    <p className="text-gray-700">Описание: {order.description}</p>
                    <p className="text-gray-700">Озвучены цены: {order.priceText}</p>
                    <p className="text-gray-700">Комиссионные: {order.commission}</p>
                    <p className="text-gray-700">
                        Быть: {order.appointmentDate} {order.appointmentTime}
                    </p>
                    <p className="text-gray-700">Клиент: {order.clientName}</p>
                    <p className="text-gray-700">Дата заявки: {order.requestDate}</p>
                    <p className="text-gray-700">Доп. инфо: {order.additionalInfo || "—"}</p>
                </div>
                <button onClick={handleTake} className="w-full bg-blue-500 py-4 rounded-full mt-4 text-white font-medium text-lg">
                    Взять заказ
                </button>
            </div>
        </div>
    );
};

export default function OrdersScreen() {
    const { availableOrders, refreshAvailableOrders, refreshPilotOrders, takeOrder } = useData();
    const { user } = useAuth();
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [sheetVisible, setSheetVisible] = useState(false);
    const [viewedOrders, setViewedOrders] = useState([]);
    const [isRefreshing, setIsRefreshing] = useState(false);

    // Обычные заказы – при монтировании и фокусе
    useEffect(() => {
        refreshAvailableOrders();
        const onFocus = () => refreshAvailableOrders();
        window.addEventListener("focus", onFocus);
        return () => window.removeEventListener("focus", onFocus);
    }, [refreshAvailableOrders]);

    const handlePilotRefresh = () => {
        setIsRefreshing(true);
        try {
            if (typeof refreshPilotOrders !== "function") {
                alert("Функция обновления пилотных заказов не найдена. Проверьте DataContext.");
                return;
            }
            refreshPilotOrders();
            console.log("Вызван refreshPilotOrders");
        } finally {
            // Сбросим индикатор через небольшой таймаут, так как запрос асинхронный
            setTimeout(() => setIsRefreshing(false), 2000);
        }
    };

    const openDetails = (order) => {
        setSelectedOrder(order);
        setSheetVisible(true);
        if (!viewedOrders.includes(order.id)) {
            setViewedOrders((prev) => [...prev, order.id]);
            if (user?.uid_master) {
                ordersAPI.viewOrder(order.orderNumber, user.uid_master).catch((e) => console.log(e));
            }
        }
    };

    return (
        <div className="px-4 pt-4">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold text-gray-800">Доступные заказы</h2>
                <button
                    onClick={handlePilotRefresh}
                    disabled={isRefreshing}
                    className={`bg-orange-500 text-white py-1 px-3 rounded-full text-sm font-medium ${isRefreshing ? "opacity-50" : ""}`}>
                    {isRefreshing ? "Загрузка..." : "Обновить"}
                </button>
            </div>

            {availableOrders.length === 0 ? (
                <div className="text-center text-gray-500 py-10">Нет доступных заказов</div>
            ) : (
                availableOrders.map((item) => (
                    <div key={item.id} className="bg-white p-4 mb-3 rounded-xl shadow-sm border border-gray-100">
                        {!viewedOrders.includes(item.id) ? (
                            <>
                                <div className="text-lg font-bold text-blue-600">НОВЫЙ ЗАКАЗ!</div>
                                <div className="text-gray-700">№ {item.orderNumber}</div>
                            </>
                        ) : (
                            <div className="text-lg font-bold text-gray-800">№ {item.orderNumber}</div>
                        )}
                        <div className="text-gray-700">{item.city}</div>
                        <div className="text-gray-700">Техника: {item.title}</div>
                        <button onClick={() => openDetails(item)} className="mt-3 bg-blue-500 px-5 py-2 rounded-full text-white">
                            Подробно
                        </button>
                    </div>
                ))
            )}

            <BottomSheet visible={sheetVisible} order={selectedOrder} onClose={() => setSheetVisible(false)} onTake={takeOrder} userId={user?.uid_master} />
        </div>
    );
}
